import { UserInvitationModalService } from "@gtmhub/users/components/user-invitation-form/user-invitation-modal.service";
import { PermissionsService, UserService, CurrentUserService, VerifyEmailComponent, VerifyUserEmailModalCtrl, RestrictedRoleConfirmationModalCtrl } from ".";
import { ChangeUserAvatarCtrl } from "./controllers/change-user-avatar";
import { MultiUserSelectorCtrl } from "./controllers/users-selector";
import "ng-file-upload/dist/ng-file-upload";
import ngImgCrop from "ng-img-crop-npm";
import files from "@gtmhub/files/module";
import { EditUserLicenseCtrl } from "./userProfile/controllers/edit-license";
import { UserProfileService } from "./userProfile/profileService";
import { CurrentUserPictureService } from "./current-user-picture-service";
import analytics from "@gtmhub/core/analytics/module";
import { UsersListCtrl } from "./controllers/users-list.ctrl";
import { UserDetailsViewCtrl } from "./controllers/user-details-view.ctrl";
import { DisabledEditNamesComponent } from "./components/disabled-edit-names/disabled-edit-names.component";
import { EditUserNamesComponent, EditUserNamesCtrl } from "./components/edit-user-names/edit-user-names.component";
import { ChangeUserPictureComponent } from "./components/change-user-picture/change-user-picture.component";
import { UserLicenseComponent } from "./components/user-license/user-license.component";
import { UserInvitationComponent } from "./components/user-invitation-form/user-invitation.component";
import { downgradeComponent } from "@angular/upgrade/static";
import { StatusActionComponent } from "@webapp/teams/components/status-action/status-action.component";

const mod = angular
  .module("users", ["ngFileUpload", files, analytics, ngImgCrop])
  .controller("ChangeUserAvatarCtrl", ChangeUserAvatarCtrl)
  .controller("EditUserNamesCtrl", EditUserNamesCtrl)
  .controller("MultiUserSelectorCtrl", MultiUserSelectorCtrl)
  .controller("UsersListCtrl", UsersListCtrl)
  .controller("UserDetailsViewCtrl", UserDetailsViewCtrl)
  .controller("EditUserLicenseCtrl", EditUserLicenseCtrl)
  .controller("VerifyUserEmailModalCtrl", VerifyUserEmailModalCtrl)
  .controller("RestrictedRoleConfirmationModalCtrl", RestrictedRoleConfirmationModalCtrl)
  .service("UserProfileService", UserProfileService)
  .service("PermissionsService", PermissionsService)
  .service("UserService", UserService)
  .service("CurrentUserService", CurrentUserService)
  .service("CurrentUserPictureService", CurrentUserPictureService)
  .service("UserInvitationModalService", UserInvitationModalService)
  .component("verifyEmail", VerifyEmailComponent)
  .component("disabledEditUserNames", DisabledEditNamesComponent)
  .component("editUserNames", EditUserNamesComponent)
  .component("changeUserPicture", ChangeUserPictureComponent)
  .component("userLicense", UserLicenseComponent)
  .component("userInvitation", UserInvitationComponent)
  .directive("statusAction", downgradeComponent({ component: StatusActionComponent }));

export default mod.name;
